<div class="content-container mb-3">
    <div class="content">
        <div class="fw-bold mb-3">
            <label>
                <mwp-text-translate text="Select a Report Template" jsonKey="selectAReportTemplate" />
            </label>
        </div>
        <mwp-table-formarray [form]="templateSelectionForm" [arrayName]="templateFormArrayName" [tableColumns]="tableColumns" [dataSource]="tableMatData" />
    </div>
    <div class="footer d-inline-flex justify-content-end w-100">
        <button class="mwp-button-secondary me-3" (click)="cancel()">
            <mwp-text-translate text="Cancel" jsonKey="cancel" />
        </button>
        <button class="mwp-button me-3" [disabled]="templateSelectionForm.invalid" (click)="save()">
            <mwp-text-translate text="Continue" jsonKey="continue" />
        </button>
    </div>
</div>